<template>
  <el-dialog :visible.sync="addDialogVisible" :close-on-click-modal="false" :title="'新建' + (appName=='salesman'?'业务端':'药潺潺') + 'APP版本'" @closed="initForm">
    <div class="dialog-content" v-loading="dialogLoading">
      <div class="dialog-tips">
        <el-alert :title="tips[formData.type]+tipTxt" type="warning" :closable="false"></el-alert>
      </div>
      <el-form :model="formData" :rules="rules" ref="formEl" label-width="100px" class="formData-box">
        <el-form-item label="版本号：" prop="version">
          <el-input v-model="formData.version" placeholder="版本号示例：0.0.0"></el-input>
        </el-form-item>
        <el-form-item label="系统类型：" prop="type">
          <el-select v-model="formData.type" placeholder="请选择系统类型">
            <el-option label="安卓系统" value="android"></el-option>
            <el-option label="ios系统" value="ios"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="更新描述：" prop="remark">
          <el-input type="textarea" v-model="formData.remark" :autosize="{ minRows: 4, maxRows: 7}" placeholder="本次版本更新描述" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="是否强更：" prop="forceUpdate">
          <el-switch class="formData-switch" v-model="formData.forceUpdate" active-value="1" inactive-value="0" active-text="是" inactive-text="否"></el-switch>
        </el-form-item>
        <el-form-item v-if="formData.type == 'android'" label="文件包：" prop="packUrl">
          <div v-if="formData.packUrl">{{ formData.apkName }} <span class="apk-del" @click="apkDel">删除</span></div>
          <div v-if="!formData.packUrl">
          <el-upload class="upload-demo"
                       accept=".apk"
                       :show-file-list="false"
                       :data="{}"
                       :headers="headers"
                       :before-upload="uploadBefore"
                       :on-success="uploadSuccess"
                       :on-error="uploadErr"
                       :on-progress="uploadProgress"
                       :action="actionUrl">
              <el-button size="small" icon="el-icon-upload" style="margin-left:8px" type="primary">上传APK包</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="submitForm">确认新增</el-button>
          <el-button @click="closeDialog">取 消</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="default" @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="submitForm" :loading="!canSubmit">确认新增</el-button>
    </div>
  </el-dialog>
</template>
  
<script>
import { getToken } from "@/utils/auth";
import { appVersionAdd } from '@/api/apk'
// const checkVersion = (_, value, callback) => {
//   // 校验版本号规则：0.0.0
//   let reg = /^\d+(\.\d+){2}$/
//   if (!reg.test(value)) {
//     return callback(new Error("请输入有效的版本号"));
//   }
//   return callback();
// };
export default {
  name: "UpdateDialog",
  data() {
    return {
      // 上传地址
      // actionUrl: 'https://gateway.cbyyk.com/product/goodsbase/upload',
      actionUrl: process.env.VUE_APP_BASE_API + '/product/goodsbase/upload',
      addDialogVisible: false,
      dialogLoading: false,
      canSubmit:true,
      tips:{
        ios: '提醒：苹果系统app升级必须是当前版本在苹果应用商店上架通过后再执行新建升级版本操作,创建版本升级后会自动跳转到苹果应用商店进行升级',
        android: '提醒：安卓版本必须上传apk包',
      },
      tipTxt:',版本号必须按照标准格式来填写且新版本号必须大于已有版本，格式为：0.0.0',
      formData: {
        version: '',
        type: 'android',
        remark: '',
        packUrl:'',
        apkName:'',
        forceUpdate:'0',
      },
      rules: {
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' },
          // { validator: checkVersion, trigger: "blur" },
          { required: true, pattern:/^\d+(\.\d+){2}$/, message: '请输入有效的版本号,版本号示例：0.0.0', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择系统类型', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请填写本次版本更新描述', trigger: 'blur' }
        ],
        forceUpdate: [
          { required: true, message: '请选择此版本是否强制更新APP', trigger: 'change' }
        ],
        packUrl: [
          { required: true, message: '请上传安卓APK文件', trigger: 'change' }
        ],
      } 
    };
  },
  props: { 
    appName: {
      type: String,
      default: "salesman",
    },
  },
  computed: {
    headers: function () {
      return {
        Authorization: 'Bearer ' + getToken(),
      }
    },
  },
  methods: {
    uploadSuccess (res) {
      this.dialogLoading = false;
      if (res.code == 0) {
        const { fileName, url } = res.data;
        // "fileName": "44552455.apk",
        // "url": "https://eshop-develop.oss-cn-hangzhou.aliyuncs.com/goods/914453644552455.apk"
        if(fileName && url){
          this.formData.packUrl = url;
          this.formData.apkName = fileName;
        }
        this.clearForm();
        this.$message.success('安卓应用包上传成功')
      }
    },
    uploadBefore(file){
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      let canUpload = fileSuffix == 'apk' || fileSuffix == 'APK';
      if(!canUpload){
        this.$message.error('请上传apk文件')
      }
      return canUpload
    },
    uploadErr(error){
      this.dialogLoading = false;
      this.$message.error('文件上传失败，请重试')
    },
    uploadProgress(event){
      this.dialogLoading = true;
      // this.dialogLoading = event.percent < 100;
    },
    apkDel(){
      this.formData.packUrl = '';
      this.formData.apkName = '';
    },
    openDialog(){
      // this.initForm();
      this.addDialogVisible = true;
    },
    closeDialog() {
      this.addDialogVisible = false;
    },
    submitForm() {
      let formRef = this.$refs.formEl;
      if(!formRef){ return; }
      // console.log('this.canSubmit', this.canSubmit,new Date())
      if(!this.canSubmit){ return; }
      this.canSubmit = false; //防止重复点击
      setTimeout(()=>{
        this.canSubmit = true;
      },800)
      formRef.validate((valid) => {
        if (valid) {
          // console.log(valid)
          const { version, type, remark, packUrl, forceUpdate } = this.formData;
          let data = { version, type, remark, packUrl, forceUpdate, appName:this.appName };
          appVersionAdd(data).then(res=>{
            this.$message.success('版本创建成功');
            this.closeDialog();
            this.$emit("submit");
          })
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
    initForm(){
      this.formData = {
        version: '',
        type: 'android',
        remark: '',
        packUrl:'',
        forceUpdate:'0',
      }
      this.clearForm();
    },
    clearForm(){
      let formRef = this.$refs.formEl;
      if(formRef){
        formRef.clearValidate();
      }
    },
    // resetForm(formName) {
      // this.$refs[formName].resetFields();
    // }
  },
  created() { },
  mounted() {},
};
</script>
  
<style scoped lang="scss">
.dialog {
  &-tips{
    margin-bottom: 12px;
  }
  // .content {}
  // .footer {}
}
.apk-del{
  margin-left: 20px;
  color: var(--main-color);
  opacity: .8;
  cursor: pointer;
  &:hover{
    opacity: 1;
  }
}
// .formData{
//   &-box{}
//   &-switch{}
// }
</style>
  